import React, { useState } from 'react';
import * as Yup from "yup";
import { sendInvoiceVericifationOtp } from '../../services/clinic/invoice';
import { Form, Formik } from 'formik';
import AsyncFormikDropdown from '../inputFields/AsyncFormikDropDown';
import { searchMasterPatientApi } from '../../services/clinic/patient_search';
import { toast } from 'react-toastify';
import InputField from '../inputFields/InputField';
import Button from '../buttons/Button';

function VerifyOtpPop({ item, onOperation }) {
    const [otpText, setOtpText] = useState("");
    const [responseOtp, setResponseOtp] = useState(null);
    const [userOptions, setUserOptions] = useState([]);

    const handleOtpFill = (value) => {
        if (value) {
            if (otpText.length !== 0) {
                if (otpText.length < 4) {
                    setOtpText(otpText + value);
                }
            } else {
                setOtpText(value);
            }
        } else {
            let updatedText = otpText.slice(0, -1);
            setOtpText(updatedText);
        }
    };

    const handleOtpSend = async (values) => {
        try {
            const formData = new FormData();
            formData.append("mobile_number", values.alt_phone);
            const response = await sendInvoiceVericifationOtp(formData);

            if (response?.status === 200) {
                toast.success("OTP Sent successfully!");
                setResponseOtp(response.data.otp);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
    };

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        if (otpText.length === 0) {
            toast.error("Provide OTP");
            return;
        } else if (otpText !== responseOtp) {
            toast.error("Wrong OTP Provided");
            return;
        }
        onOperation();
        resetForm();
        setOtpText("");
        setResponseOtp(null);
    };

    return (<div className='w-full flex-1 mt-2'>
        <Formik
            initialValues={{
                phone: "",
                alt_phone: "",
                otp: "",
            }}
            validationSchema={Yup.object({
                alt_phone: Yup.string().required("Phone is mendatory"),
            })}
            onSubmit={handleFormSubmit}
        >
            {({ isSubmitting, setFieldValue, values }) => (
                <Form>
                    <div className="grid gap-2 grid-cols-1 border border-gray-300 p-4 rounded-lg bg-gray-100">
                        <AsyncFormikDropdown
                            label="Patient ID"
                            name="patient"
                            placeholder="Select Patient"
                            apiCallFunction={async (input) => {
                                const response = await searchMasterPatientApi(input);
                                setUserOptions(response.data);
                                return response.data.map((patient) => ({
                                    value: patient.id,
                                    label: `${patient.patient_name} | ${patient.patient_phone}`,
                                }));
                            }}
                            required
                            needSearch={true}
                            onChange={(selectedOption) => {
                                // Find the corresponding patient data                                            
                                const selectedPatient = userOptions.find(
                                    (item) => item.id === selectedOption.value
                                );

                                if (selectedPatient) {
                                    setFieldValue("phone", selectedPatient.patient_phone);
                                    setFieldValue("alt_phone", selectedPatient.patient_phone);
                                }
                            }}
                        />
                        <InputField
                            label="Phone"
                            name="phone"
                            type="text"
                            placeholder="Enter Phone Number"
                            required
                            className="hidden"
                            disable
                        />
                        <InputField
                            label="Alt. Phone"
                            name="alt_phone"
                            type="text"
                            placeholder="Enter Phone Number"
                            className={responseOtp ? "" : "hidden"}
                            required
                        />
                        <div className="flex flex-col justify-end pb-2">
                            <Button
                                type="button"
                                className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                onClick={() => handleOtpSend(values)}>
                                Generate OTP
                            </Button>
                        </div>
                        <InputField
                            label="OTP"
                            name="otp"
                            placeholder={"Enter OTP"}
                            type="number"
                            value={otpText}
                            onChange={(val) => handleOtpFill(val.nativeEvent.data)}
                            required
                        />
                        <div className="flex flex-col justify-end pb-2">
                            <Button
                                type="submit"
                                className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                disabled={isSubmitting || responseOtp === null}
                            >
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </Button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    </div>);
}

export default VerifyOtpPop;